import styled, { css } from "styled-components";
const ErrorBoundaryStyled = styled.div.withConfig({
  displayName: "ErrorBoundaryStyled",
  componentId: "sc-6mtycb-0"
})(["", ";"], () => {
  return css(["details{white-space:'pre-wrap',line-height:1.2,}"]);
});
ErrorBoundaryStyled.displayName = "ErrorBoundaryStyled";
export default ErrorBoundaryStyled;